/**
 * XREF01 / XREF02: "ReferralAdditional (HenvisningsTillægsDiagnose) max. x 5"
 * (MedCom Den gode XML sygehushenvisning, XREF01.pdf Del B; same in XREF02.pdf).
 * Under Refer - DiagnoseCode: "det er obligatorisk at sende en ICD10-kodet
 * henvisningsdiagnose, og der skal gives mulighed for at medsende 5
 * bidiagnoser/tillægsdiagnoser."
 */
export const MAX_ADDITIONAL_DIAGNOSES = 5;

/** Rows already on the form, filled or not, count towards the limit. */
export function canAddAdditionalDiagnosis(rowCount: number): boolean {
  return rowCount < MAX_ADDITIONAL_DIAGNOSES;
}
